<template>
    <div class="main-modal">
        <modal name="modal-enter" v-bind="{...options, width: 368, minHeight: 510}" @before-open="beforeOpen">
            <span class="main-modal__close" @click="close()">
                <svg><use xlink:href="#svg-close"></use></svg>
            </span>
            <modal-enter :result="modalData.params" />
        </modal>
        <modal name="modal-password-recovery" v-bind="{...options, width: 368}" @before-open="beforeOpen">
            <span class="main-modal__close" @click="close()">
                <svg><use xlink:href="#svg-close"></use></svg>
            </span>
            <modal-password-recovery :result="modalData.params" />
        </modal>
        <modal name="modal-registration" v-bind="{...options, width: 368, minHeight: 590}" @before-open="beforeOpen">
            <span class="main-modal__close" @click="close()">
                <svg><use xlink:href="#svg-close"></use></svg>
            </span>
            <modal-registration :result="modalData.params" />
        </modal>
    </div>
</template>

<script>
    export default {
        name: 'main-modal',
        selector: '.main-modal',
        data() {
            return {
                modalData: {},
                options: {
                    adaptive: true,
                    height: 'auto'
                }
            }
        },
        methods: {
            close() {
                this.$DefModal.hide();
            },
            beforeOpen(modalData) {
                this.modalData = modalData;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-modal{
        &__close {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 2;
            width: 25px;
            height: 25px;
            svg {
                width: 12px;
                height: 12px;
                fill: grey;
            }
            &:hover{
                cursor: pointer;
            }
        }
    }
</style>